/**
 * Replaces [singularPlural singular="singular_word" plural="plural_word"] shortcodes
 * with the appropriate form based on count
 *
 * @param props - Function parameters
 * @param props.context - Shortcode context containing text
 * @param props.count - Number to determine singular/plural form
 *
 * @returns void - Updates the context.text directly with the replaced shortcodes
 *
 * @example
 * ```ts
 * applySingularPlural({
 *   context: { text: '[singularPlural singular="user" plural="users"]', locale: "en" },
 *   count: 1
 * });
 * // Result: 'user'
 *
 * applySingularPlural({
 *   context: { text: '[singularPlural singular="user" plural="users"]', locale: "en" },
 *   count: 2
 * });
 * // Result: 'users'
 * ```
 */

import { ShortcodeContext } from '../..';
import { applyShortcode } from '../../utils/applyShortcode';

export const applySingularPlural = ({
  context,
  count,
}: {
  context: ShortcodeContext;
  count: number;
}) => {
  context.text = applyShortcode(context.text, 'singularPlural', (match) => {
    const { attributes } = match;
    const { singular, plural } = attributes;
    return count <= 1 ? singular : plural;
  });
};
